import Divider from "@mui/material/Divider";
import "./EnvDataTable.css";
import React, { useEffect } from "react";
import SkeletonComponent from "./SkeletonComponent.tsx";
import { useDevicesContext } from "../../../context/DevicesContext.tsx";
import { useWebSocketContext } from "../../../context/WebSocketContext.tsx";
import moment from "moment";

export default function EnvDatatable() {
    const { data, isLoading } = useDevicesContext();
    const { socketData, isConnected } = useWebSocketContext(); 

    const formatDate = (dateString) => {
            return <span className="triggers-page-date" style={{ fontSize: "13px" }}>{moment(dateString).format('DD/MM/YYYY  hh:mm:ss A')}</span>;
        };

    // useEffect(() => {
    //     console.log("WebSocket Data:", socketData);
    // }, [socketData]); 

    const mergedData = data?.map((backendItem) => {
        const socketItem = socketData?.find((socket) => socket.store_id === backendItem._id);

        if (isConnected) {
            return socketItem?.temperature_sensor
                ? { ...backendItem, temperature_sensor: socketItem.temperature_sensor }
                : backendItem; 
        }
        return backendItem;
    }); 

    return (
        <>     
            <div className="devices-heading-env-data">
                <div className="devices-heading-env-data-store-name">
                    <span className="devices-heading-env-data-store-name-text">Store Name</span>
                </div>
                <div className="devices-heading-env-data-temperature">
                    <span className="devices-heading-env-data-temperature-text">Temperature</span>
                </div>
                <div className="devices-heading-env-data-temperature">
                    <span className="devices-heading-env-data-temperature-text">Humidity</span>
                </div>
                <div className="devices-heading-env-data-humidity">
                    <span className="devices-heading-env-data-humidity-text">Battery</span>
                </div>
                <div className="devices-heading-env-data-humidity">
                    <span className="devices-heading-env-data-humidity-text">Last Updated</span>
                </div>
            </div>
            {!isLoading && <Divider variant="middle" />}
            {isLoading ? (
                <SkeletonComponent />
            ) : (
                mergedData
                    ?.filter(
                        (item) =>
                            item?.temperature_sensor || item?.configs?.sensors?.temperature_sensor?.[0]?.temperature
                    )
                    .map((item) => {
                        const temperatureSensorData =
                            item?.temperature_sensor || item?.configs?.sensors?.temperature_sensor?.[0] || {};

                        return (
                            <React.Fragment key={item?._id}>
                                <div className="devices-env-data-box-container">
                                    <div className="devices-store-name">
                                        <div className="devices-env-data-store-name-text">
                                            {item.name || "Unknown Store"}
                                        </div>
                                    </div>
                                    <div className="devices-env-data-box-temperature">
                                        <span style={{ color: "teal" }}>
                                            {temperatureSensorData.temperature || "N/A"}°C
                                        </span>
                                    </div>
                                    <div className="devices-env-data-box-humidity">
                                        <span>{temperatureSensorData.humidity || "N/A"}%</span>
                                    </div>
                                    <div className="devices-env-data-box-temperature" style={{ color: "teal" }}>
                                        <span>{temperatureSensorData.battery || "N/A"}</span>
                                    </div> 
                                    <div className="devices-env-data-box-humidity">
                                        <span>
                                            {formatDate(temperatureSensorData.last_updated) || "N/A"}
                                        </span>
                                    </div>
                                </div>
                                <Divider variant="middle" />
                            </React.Fragment>
                        );
                    })
            )}
        </>
    );
}
